window.STUDYFLEX_STORES = window.STUDYFLEX_STORES || [];

document.addEventListener("alpine:init", () => {
  STUDYFLEX_STORES.forEach((scope) => {
    const storePrefix = scope ? scope + "_" : "";
    const storeName = `${storePrefix}studyFlex`;

    const storeDefaultValues = {
      firstLevelFilters: {
        studyLevels: [],
        academicYears: [],
        studyFlexOptions: [],
      },

      secondLevelFilters: {
        disciplines: [],
        locations: [],
      },
    };

    Alpine.store(storeName, {
      // persistable data
      firstLevelFilters: { ...storeDefaultValues.firstLevelFilters },
      secondLevelFilters: { ...storeDefaultValues.secondLevelFilters },

      // search results
      allAcademicItems: {},
      filteredAcademicItems: [],
      hideResultComponent: false,

      isLoading: false,
    });

    Alpine.data(`${storeName}PersistProxy`, function () {
      return {
        firstLevelFilters: this.$persist({
          ...storeDefaultValues.firstLevelFilters,
        }).as(`${storeName}_firstLevelFilters`),
        secondLevelFilters: this.$persist({
          ...storeDefaultValues.secondLevelFilters,
        }).as(`${storeName}_secondLevelFilters`),
        // resultSortBy: this.$persist(storeDefaultValues.resultSortBy).as(
        //   `${storeName}_resultSortBy`
        // ),

        init() {
          const attrs = [
            "firstLevelFilters",
            "secondLevelFilters",
            "studyFlexOptions",
            // "resultSortBy",
          ];

          // setting default value
          attrs.forEach((attrName, i) => {
            this.$store[storeName][attrName] = this[attrName];
          });

          // setup watcher to set and persist value when value changed
          attrs.forEach((attrName, i) => {
            this.$watch(`$store.${storeName}.${attrName}`, (newVal) => {
              this[attrName] = newVal;
            });
          });
        },
      };
    });
  });
});

(() => {
  STUDYFLEX_STORES.forEach((scope) => {
    const storePrefix = scope ? scope + "_" : "";
    const storeName = `${storePrefix}studyFlex`;

    // add a proxy element to DOM
    const div = document.createElement("div");
    div.setAttribute("x-data", `${storeName}PersistProxy`);
    div.setAttribute("style", "display: none");

    // make sure proxy logic will be run first
    document.body.insertBefore(div, document.body.firstChild);
  });
})();
